import React, { useState } from 'react';
import {
  Alert,
  Anchor,
  Button,
  Center,
  Checkbox,
  Container,
  Group,
  Loader,
  Paper,
  SimpleGrid,
  Text,
  TextInput,
  Textarea,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import * as classes from './FormContatto.module.css';
import ButtonBlock from '../ButtonBlock';
import googleAnalyticsWrapper from '../../utils/googleAnalyticsWrapper';


function FormContatto({
  formContattoData: {
    formContattiTitolo,
    formContattiTestoIntroduttivo,
    formContattiFormTitolo,
    formContattiFormTesto,
    formContattiButtons,
    stub,
    modalDisplay = false,
  },
}) {
  const [formFeedback, setFormFeedback] = useState({
    spinner: false,
    message: '',
    success: false,
  });

  const form = useForm({
    initialValues: {
      email: '',
      nome: '',
      telefono: '',
      richiesta: '',
      privacy: '',
    },
    validate: {
      email: (value) => {
        if (!value) {
          return 'Campo obbligatorio';
        } if (!/^[\w.-]+(\+\w+)?@[\w.-]+\.[\w.]{2,}$/i.test(value)) {
          return 'Indirizzo email non valido';
        }
        return undefined;
      },
      nome: (value) => (value ? undefined : 'Campo obbligatorio'),
      richiesta: (value) => (value ? undefined : 'Campo obbligatorio'),
      privacy: (value) => (value ? undefined : 'Campo obbligatorio'),
    },
    validateInputOnChange: true,
  });

  const mostraFormLeft = !!formContattiTitolo || !!formContattiTestoIntroduttivo || !!formContattiButtons.length;

  return (
    <Container
      fluid
      p={modalDisplay ? 0: 'sm'}
    >
      <Container p={0}>
        <Paper shadow="md" radius="lg" classNames={{ root: classes.paperRoot }}>
          <div className={classes.wrapper}>
            {mostraFormLeft && (
              <div className={classes.contacts}>
                {formContattiTitolo && (
                  <Text mb="md" fz="lg" fw={700} className={classes.title}>
                    {formContattiTitolo}
                  </Text>
                )}

                {formContattiTestoIntroduttivo && (
                  <Text className={classes.description}>{formContattiTestoIntroduttivo}</Text>
                )}

                {!!formContattiButtons.length && (
                  <Group justify="center">
                    <ButtonBlock buttons={formContattiButtons.map(({ googleAnalyticsEventPayload, ...b }) => ({
                      ...b,
                      googleAnalyticsEventPayload: JSON.stringify({
                        category: "form_contatti",
                        action: `form_contatti_${modalDisplay ? 'modal' : 'page'}_btn_prenota${googleAnalyticsEventPayload?.action || ''}`,
                        label: `Form contatti da ${modalDisplay ? 'button help' : 'pagina'}pulsante prenota${googleAnalyticsEventPayload?.label || ''}`,
                      })
                    }))} />
                  </Group>
                )}
              </div>
            )}

            <div className={mostraFormLeft ? classes.formWrapper : classes.formWrapperNoPadding}>
              {(!formFeedback?.spinner || formFeedback?.message) && (
                <Center>
                  {formFeedback?.spinner && (
                    <Loader color="secondary" size="xl" type="dots" />
                  )}
                  {formFeedback?.message && (
                    <Alert
                      mb="md"
                      className={classes.mantineAlertRoot}
                      variant="light"
                      color={formFeedback.success ? 'green' : 'red'}
                      title={formFeedback.success ? 'Messaggio inviato' : 'Errore nell\'invio del messaggio'}
                    >
                      {formFeedback.success && (
                        <>Grazie per averci contattato, ti risponderemo il prima possibile!</>
                      )}
                      {!formFeedback.success && (
                        <>Si è verificato un errore, prova a ripetere l'invio del messaggio</>
                      )}
                    </Alert>
                  )}
                </Center>
              )}

              {!formFeedback?.spinner && !formFeedback.success && (
                <form
                  className={classes.form}
                  onSubmit={form.onSubmit(({
                    email, nome, telefono, richiesta
                  }) => {
                    const ticket = {
                      subject: 'Richiesta di informazioni',
                      tags: ['form_contatto_landing', modalDisplay && 'modal', `pagina_${stub.replace(/\//g, '')}`].filter((f) => (f)),
                      comment: {
                        body: `${richiesta}\n${telefono ? `Numero di telefono: ${telefono}` : ''}`,
                      },
                      requester: {
                        locale_id: 22,
                        name: nome,
                        email,
                      },
                      assignee_id: 767746652,
                    };

                    setFormFeedback({
                      spinner: true,
                      message: '',
                      success: false,
                    });

                    fetch('https://academy.maieuticallabs.it/cicero_academy/api/zendesk', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({ ticket }),
                    })
                      .then((response) => response.json())
                      .then(() => {
                        setFormFeedback({
                          spinner: false,
                          message: 'La tua richiesta è stata inviata correttamente',
                          success: true,
                        });
                        googleAnalyticsWrapper('event', {
                          category: "form_contatti",
                          action: `form_contatti_invio_richiesta_${modalDisplay ? 'modal' : 'page'}`,
                          label: `Form contatti invio richiesta da ${modalDisplay ? 'button help' : 'pagina'}`,
                        });
                      })
                      .catch(() => {
                        setFormFeedback({
                          spinner: false,
                          message: 'Non ho potuto inviare la tua richiesta, riprova',
                          success: false,
                        });
                      });
                  })}
                >
                  {formContattiFormTitolo && (
                    <Text fz="lg" mb="md" fw={700} className={classes.title}>
                      {formContattiFormTitolo}
                    </Text>
                  )}

                  {formContattiFormTesto && (
                    <Text className={classes.description} mb="xl">{formContattiFormTesto}</Text>
                  )}

                  <div className={classes.fields}>
                    <TextInput
                      label="Email"
                      placeholder="latuaemail@example.com"
                      required
                      {...form.getInputProps('email')}
                    />
                    <SimpleGrid cols={{ base: 1, xs: 2 }}>
                      <TextInput
                        label="Nome"
                        placeholder="Giovanna Rossi"
                        required
                        {...form.getInputProps('nome')}
                      />

                      <TextInput
                        label="Telefono (opzionale)"
                        {...form.getInputProps('telefono')}
                      />
                    </SimpleGrid>

                    <Textarea
                      required
                      resize="vertical"
                      label="La tua richiesta"
                      placeholder="Avrei bisogno di informazioni su..."
                      {...form.getInputProps('richiesta')}
                    />

                    <Checkbox
                      mt="md"
                      label={(
                        <Text>Ho letto e compreso la <Anchor target="_blank" href="https://maieuticallabs.it/privacy/">normativa sulla privacy</Anchor></Text>
                      )}
                      {...form.getInputProps('privacy')}
                    />

                    <Group justify="flex-end" mt="md">
                      <Button color="brand" type="submit" disabled={!form.isValid()}>
                        Invia messaggio
                      </Button>
                    </Group>
                  </div>
                </form>
              )}
            </div>
          </div>
        </Paper>
      </Container>
    </Container>
  );
}

export default FormContatto;
